/* eslint-disable @typescript-eslint/naming-convention */
export enum MonthType {
    None = 'None',
    January = 'January',
    February = 'February',
    March = 'March',
    April = 'April',
    May = 'May',
    June = 'June',
    July= 'July',
    August ='August',
    September = 'September',
    October ='October',
    November ='November',
    December ='December'
}
